import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DmPhongHoc } from '../../services/phong-hoc/PhongHocModels';

interface PhongHocState {
    listData: DmPhongHoc[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    selectedId: number | null;
    isShowCreateOrEditModal: boolean;
    isShowConfirmDeleteModal: boolean;
    createOrEditModel: DmPhongHoc | null;
}

const initialState: PhongHocState = {
    listData: [],
    status: 'idle',
    selectedId: null,
    isShowCreateOrEditModal: false,
    isShowConfirmDeleteModal: false,
    createOrEditModel: null
};

const phongHocSlice = createSlice({
    name: 'phongHoc',
    initialState,
    reducers: {
        setList: (state, action: PayloadAction<DmPhongHoc[]>) => {
            state.listData = action.payload;
        },
        setStatus: (state, action: PayloadAction<PhongHocState['status']>) => {
            state.status = action.payload;
        },
        selectPhongHoc: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        setCreateOrEditModel: (state, action: PayloadAction<DmPhongHoc | null>) => {
            state.createOrEditModel = action.payload;
        },
        setShowCreateOrEditModal: (state, action: PayloadAction<boolean>) => {
            state.isShowCreateOrEditModal = action.payload;
        },
        setShowConfirmDeleteModal: (state, action: PayloadAction<{ show: boolean; id?: number }>) => {
            state.isShowConfirmDeleteModal = action.payload.show;
            state.selectedId = action.payload.id ?? null;
        },
        insertSuccess: (state, action: PayloadAction<DmPhongHoc>) => {
            state.listData.push(action.payload);
            state.isShowCreateOrEditModal = false;
        },
        updateSuccess: (state, action: PayloadAction<DmPhongHoc>) => {
            const index = state.listData.findIndex((item) => item.ID_phong === action.payload.ID_phong);
            if (index !== -1) {
                state.listData[index] = action.payload;
            }
            state.isShowCreateOrEditModal = false;
        },
        deleteSuccess: (state, action: PayloadAction<number>) => {
            state.listData = state.listData.filter((item) => item.ID_phong !== action.payload);
            state.isShowConfirmDeleteModal = false;
            if (state.selectedId === action.payload) {
                state.selectedId = null;
            }
        },
        resetState: () => initialState
    }
});

export const {
    setList,
    setStatus,
    selectPhongHoc,
    setCreateOrEditModel,
    setShowCreateOrEditModal,
    setShowConfirmDeleteModal,
    insertSuccess,
    updateSuccess,
    deleteSuccess,
    resetState
} = phongHocSlice.actions;

export const phongHocReducer = phongHocSlice.reducer;
